export const ImageKitPublicKey = process.env.REACT_APP_IMAGEKIT_PUBLIC_KEY;
export const TestAdminUid = process.env.REACT_APP_TEST_ADMIN_UID;
